/* global localStorage */
import React, { Component } from 'react'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import Alerts from '../components/ui/Alerts'
import ContactSupport from '../components/help/ContactSupport'
import PrivateRoute from '../components/PrivateRoute'
import { contactSupport } from '../actions/ui'
import { checkLogin } from '../actions/auth'
import { alert } from '../actions/alerts'
import config from '../config'
import Loading from '../components/Loading'

import Login from './Login'
import Logout from './Logout'
import ResetPassword from './ResetPassword'
import Signup from './Signup'
import Main from './Main'
import Dashboard from './Dashboard'
import PageNotFound from './PageNotFound'

const currentSite = localStorage.getItem('currentSite')

@withRouter
@connect(({auth, ui, sites}) => ({
  auth,
  loaded: auth.loaded,
  showing: ui.contactModal
}),
(dispatch) => ({
  dispatch,
  contactSupport: () => dispatch(contactSupport())
}))
@DragDropContext(HTML5Backend)
export default class App extends Component {
  componentDidMount () {
    const {auth, dispatch} = this.props
    checkLogin(auth, dispatch)

    const {name, versionNumber} = config.browser
    if (name === 'ie' && versionNumber < 10) {
      dispatch(alert({message: 'Your browser is unsupported. Please upgrade your browser to the latest version.', type: 'error'}))
    }
  }

  componentWillReceiveProps (nextProps) {
    // auth loaded state changed, re-check auth
    if (!nextProps.loaded && this.props.loaded) {
      const {auth, dispatch} = nextProps
      checkLogin(auth, dispatch)
    }
  }

  render () {
    const {showing, contactSupport, loaded} = this.props

    const routes = []

    if (loaded) {
      routes.push(
        <PrivateRoute key='new' exact path='/new' component={Dashboard} />,
        <PrivateRoute key='dashboard' path='/dashboard' component={Dashboard} />,
        <PrivateRoute key='main' path='/:siteId' component={Main} />,
        <Redirect key='redir' exact from='/' to={currentSite ? `/${currentSite}` : '/dashboard'} />,
        <Route key='notfound' component={PageNotFound} />
      )
    } else {
      routes.push(
        <Route key='loading' render={() => <Loading type='container' />} />
      )
    }

    return <div>
      <Alerts />
      <Switch>
        <Route exact path='/login' component={Login} />,
        <Route exact path='/reset' component={ResetPassword} />,
        <Route exact path='/signup' component={Signup} />
        <Route exact path='/logout' component={Logout} />,
        {routes}
      </Switch>
      <ContactSupport showing={showing} onClose={contactSupport} />
    </div>
  }
}




// WEBPACK FOOTER //
// ./app/containers/App.js